<template>
    <div class="login-container">
        <loading :isLoading="isLoading" />
        <div class="login-form">
            <div><img class="logo" :src="logo" alt="Força de vendas" /></div>
            <div v-if="emailEnviado" class="has-text-centered">
                <h1 class="title is-4">
                    <b-icon icon="email" type="is-primary" />
                    {{ $t('enviado-com-sucesso') }}
                </h1>
                <hr />
                <h2 class="title is-5">{{ $t('verifique-seu-e-mail-e-clique-no-link') }}</h2>
            </div>

            <div class="form-columns-fit" v-else-if="alterarSenha">
                <div class="columns is-flex-wrap mb-4">
                    <div class="column is-12">
                        <p class="mb-2">
                            <i>
                                Devido às regras da
                                <a
                                    href="http://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
                                    target="_blank"
                                    >LGPD</a
                                >
                                estamos fazendo algumas mudanças em nosso sistema.
                                <br />
                                Por favor insira uma nova senha seguindo os parâmetros citados
                                abaixo.
                            </i>
                        </p>
                        <p>
                            {{ $t('regra-senha') }}
                        </p>
                    </div>
                    <div class="column is-12">
                        <v-input
                            id="password_new"
                            ref="password_new"
                            :hideInfo="hide.hideInfo"
                            :infoIsHidden="hide.infoIsHidden"
                            v-model="form.senha"
                            placeholder="placeholder-preencha"
                            :maxlength="50"
                            title="senha"
                            type="password"
                            :invalid="isNull(form.senha)"
                            :disabled="isLoading"
                            required
                            :uppercase="false"
                        />
                    </div>
                    <div class="column is-12">
                        <v-input
                            id="password_new_repeat"
                            ref="password_new_repeat"
                            :hideInfo="hide.hideInfo"
                            :infoIsHidden="hide.infoIsHidden"
                            v-model="form.senha2"
                            placeholder="placeholder-preencha"
                            :maxlength="50"
                            title="repetir-senha"
                            type="password"
                            :invalid="isNull(form.senha2)"
                            :disabled="isLoading"
                            required
                            :uppercase="false"
                        />
                    </div>

                    <div class="column is-12 has-text-centered">
                        <b-button
                            type="is-primary"
                            @click="alteracaoSenha()"
                            icon-left="check"
                            :disabled="isLoading"
                        >
                            {{ $t('alterar-senha') }}
                        </b-button>
                    </div>
                </div>
            </div>
            <div class="form-columns-fit" v-else>
                <div class="columns is-flex-wrap mb-4">
                    <div class="column is-12">
                        <v-input
                            ref="email"
                            key="email"
                            v-model="form.email"
                            placeholder="placeholder-preencha"
                            :maxlength="100"
                            title="email"
                            :msg="invalidEmailMsg"
                            :invalid="invalidEmail"
                            :onBlurFunction="validateEmailInner"
                            :disabled="isLoading"
                            required
                            :uppercase="false"
                            :onKeyUp="onKeyUp"
                        />
                    </div>
                    <div class="column is-12" v-if="!recuperarSenha">
                        <v-input
                            id="password"
                            ref="password"
                            :hideInfo="hide.hideInfo"
                            :infoIsHidden="hide.infoIsHidden"
                            v-model="form.senha"
                            placeholder="placeholder-preencha"
                            :maxlength="50"
                            title="senha"
                            type="password"
                            :invalid="isNull(form.senha)"
                            :disabled="isLoading"
                            required
                            :uppercase="false"
                            :onKeyUp="onKeyUp"
                        />
                    </div>
                    <!-- <div class="column is-6" v-if="!recuperarSenha">
                        <b-switch v-model="form.keepLogged">
                            {{ $t('continuar-conectado') }}
                            <b-icon
                                icon="information"
                                size="is-small"
                                :title="$t('continuar-conectado-msg')"
                                class="mt-1"
                            />
                        </b-switch>
                    </div> -->

                    <div class="column is-12 has-text-right-desktop" v-if="!recuperarSenha">
                        <b-button
                            type="is-primary"
                            @click="recaptcha()"
                            icon-left="login"
                            :disabled="isLoading"
                        >
                            {{ $t('entrar') }}
                        </b-button>
                    </div>
                    <div class="column is-12 has-text-centered" v-else>
                        <b-button
                            type="is-primary"
                            @click="solicitaAlteracaoSenha()"
                            icon-left="lock-reset"
                            :disabled="isLoading"
                        >
                            {{ $t('recuperar-senha') }}
                        </b-button>
                    </div>
                </div>
            </div>

            <div>
                <a
                    v-if="!recuperarSenha && !alterarSenha"
                    href="#"
                    @click.prevent="recuperarSenha = true"
                >
                    {{ $t('esqueci-senha') }}
                </a>
                <a
                    v-else
                    href="#"
                    @click.prevent="
                        recuperarSenha = false;
                        emailEnviado = false;
                        alterarSenha = false;
                        alterarSenhaMobile = true;
                        removeRouteParams();
                    "
                >
                    {{ $t('voltar-para-login') }}
                </a>
            </div>

            <div class="column is-12 is-size-7 has-text-centered">
                Este site é protegido pelo reCAPTCHA e a
                <a target="new" href="https://policies.google.com/privacy">
                    Política de Privacidade
                </a>
                e os
                <a target="new" href="https://policies.google.com/terms"> Termos de Serviço </a>
                do Google se aplicam.
            </div>
        </div>
        <div class="login-info">
            <p>{{ $t('msg-login-transforme') }}</p>
            <p>{{ $t('msg-login-tenha-mais') }}</p>
            <p>{{ $t('msg-login-acabe-com') }}</p>
            <p>{{ $t('msg-login-tenha-na-palma') }}</p>
        </div>
        <!-- Language -->
        <div id="lang-login">
            <b-dropdown aria-role="list">
                <div
                    slot="trigger"
                    class="clicable"
                    title="Mudar linguagem; Change language; Cambiar idioma"
                >
                    <svg class="svg-icons">
                        <use
                            :xlink:href="
                                require(`@/assets/img/langflags/${$i18n.locale}.svg`) + '#layer'
                            "
                        />
                    </svg>
                </div>

                <b-dropdown-item
                    aria-role="listitem"
                    v-for="(language, i) in ['pt', 'en', 'es']"
                    :key="i"
                    @click="changeLanguage(language)"
                >
                    <svg class="svg-icons">
                        <use
                            :xlink:href="
                                require(`@/assets/img/langflags/${language}.svg`) + '#layer'
                            "
                        />
                    </svg>
                    <span class="ml-1" v-text="$t(language)" />
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div id="copyright-login" class="is-size-7">
            © {{ $t('sovis') }} - {{ new Date() | moment('YYYY') }}
        </div>
    </div>
</template>
<script>
import * as Init from '@/functions/Init.js';
import { mapState } from 'vuex';

export default {
    name: 'Login',
    data() {
        return {
            logo: require('@/assets/img/logo_sovis_bg.png'),
            isLoading: false,
            form: {
                email: null,
                senha: null,
                senha2: null,
                keepLogged: true,
                id_fvw_usuario: 0,
                id_vendedor: 0,
            },
            suporte: false,
            invalidEmailMsg: 'msg-campo-obrigatorio',
            invalidEmail: false,

            recuperarSenha: false,
            emailEnviado: false,
            alterarSenha: false,
            alterarSenhaMobile: false,
        };
    },
    computed: {
        ...mapState(['keepLogged', 'hide', 'user', 'context', 'authenticated']),
    },
    created() {
        this.setLogo();
        // liberação de senha diária
        if (!this.isNull(this.$route.query.suporte)) {
            this.suporte = true;
        }
        // recuperaçãod e senha
        if (!this.isNull(this.$route.query.codigo) && !this.alterarSenha) {
            if (!this.isNull(this.$route.query.from) && this.$route.query.from == 'mobile') {
                this.recuperarSenhaCheckMobile();
            } else {
                this.recuperarSenhaCheck();
            }
        }
    },
    methods: {
        onKeyUp(evento) {
            if (evento.key != undefined && evento.key == 'Enter') {
                this.recaptcha();
            }
        },
        recaptcha(logout = false) {
            if (process.env.NODE_ENV != 'development') {
                this.$recaptchaLoaded().then(() => {
                    this.$recaptcha('login')
                        .then((token) => {
                            this.$axios.defaults.headers['Gr-Token'] = token;
                            this.login(logout);
                        })
                        .catch((error) => {
                            console.log('error', error);
                            this.$axios.defaults.headers['Gr-Token'] = null;
                        });
                });
            } else {
                this.login(logout);
            }
        },
        setLogo() {
            if (this.$store.state.partnerSystemHasLayout.url_logotipo_web != null) {
                this.logo = this.$store.state.partnerSystemHasLayout.url_logotipo_web;
            }
        },
        setFavicon() {
            let faviconElement = document.getElementById('favicon');
            if (this.$store.state.partnerSystemHasLayout.url_icone_web != null) {
                faviconElement.href = this.$store.state.partnerSystemHasLayout.url_icone_web;
            } else {
                faviconElement.href = this.favicon;
            }
        },
        validateEmailInner() {
            if (this.isNull(this.form.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = 'msg-campo-obrigatorio';
            } else if (!this.validateEmail(this.form.email)) {
                this.invalidEmail = true;
                this.invalidEmailMsg = 'msg-campo-invalido';
            } else {
                this.invalidEmail = false;
            }
        },
        login(logout = false) {
            this.validateEmailInner();
            this.isLoading = true;

            if (this.invalidEmail || this.isNull(this.form.senha)) {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isLoading = false;
                return;
            }

            // encripta login
            let emailEncripted = this.$CryptoJS.AES.encrypt(
                this.form.email,
                atob(process.env.VUE_APP_DK)
            ).toString();
            // encripta senha
            let senhaEncripted = this.$CryptoJS.AES.encrypt(
                this.form.senha,
                atob(process.env.VUE_APP_DK)
            ).toString();

            let credentials = {
                username: emailEncripted,
                password: senhaEncripted,
                logoutAnother: logout,
                suporte: this.suporte,
            };

            this.doLogin(credentials);
        },
        doLogin(credentials) {
            this.$axios
                .post('user/login', credentials)
                .then((response) => {
                    if (response.data.status == 500) {
                        this.showMassage(response.data.message);
                        this.isLoading = false;
                        return;
                    }
                    this.configureLogin(response);
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.showMassage(error.data.message);
                    }
                    this.isLoading = false;
                });
        },
        configureLogin(response) {
            this.$axios.defaults.headers['Gr-Token'] = null;
            // Calculando tempo dependendo da opção de manter conectado
            // let timeToExpire = this.form.keepLogged ? '1m' : '1h';
            // this.$cookies.set('keepLogged', this.form.keepLogged, timeToExpire);
            // this.$cookies.set('id_layout', response.data.content, timeToExpire);
            this.$cookies.set('keepLogged', this.form.keepLogged);
            this.$cookies.set('id_layout', response.data.content);

            this.getTheme();
        },
        getTheme() {
            Init.getTheme(this.$store)
                .finally((_) => {
                    this.setLogo();
                    this.setFavicon();
                    this.getUsuario();
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        getUsuario() {
            Init.getUsuario(this.$store)
                .then((res) => {
                    this.getUsuarioMenu();
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        getUsuarioMenu() {
            Init.getUsuarioMenu(this.$store)
                .then((res) => {
                    this.getModuloPDA();
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        getModuloPDA() {
            Init.getModuloPDA(this.$store)
                .then((res) => {
                    this.getEmpresa();
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        getEmpresa() {
            Init.getEmpresa(this.$store)
                .then((res) => {
                    let replaceBy = this.getTelaDefaultByContext(this.context);

                    this.isLoading = false;
                    this.$store.dispatch('authenticated', { value: true });

                    if (replaceBy != null) {
                        this.$router.push({ name: replaceBy });
                    }
                })
                .catch(() => {
                    this.isLoading = false;
                });
        },
        showMassage(message = null) {
            this.$cookies.remove('keepLogged');
            if (message == 'user-already-logged') {
                this.confirmModal(message);
            } else {
                this.$root.showMessage(
                    'alert',
                    this.getTranslation(message, 'erro-entrar-sistema'),
                    true,
                    false
                );
            }
        },
        confirmModal(message) {
            this.$root.confirm({
                message: this.$t(message),
                onConfirm: (_) => this.recaptcha(true),
            });
        },
        solicitaAlteracaoSenha() {
            this.validateEmailInner();
            this.isLoading = true;

            if (this.invalidEmail) {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isLoading = false;
                return;
            }

            // encripta login
            let emailEncripted = this.$CryptoJS.AES.encrypt(
                this.form.email,
                atob(process.env.VUE_APP_DK)
            ).toString();

            let credentials = {
                username: emailEncripted,
            };

            this.doSolicitaAlteracaoSenha(credentials);
        },
        doSolicitaAlteracaoSenha(credentials) {
            this.$axios
                .post('user/solicita-alteracao-senha', credentials)
                .then((response) => {
                    if (response.data.status == 500) {
                        this.showMassage(response.data.message);
                        this.isLoading = false;
                        return;
                    }
                    this.emailEnviado = response.data.content;
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.showMassage(error.data.message);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        recuperarSenhaCheck() {
            let credentials = {
                codigorecuperacao: this.$route.query.codigo,
            };

            this.$axios
                .post('user/recuperar-senha-check', credentials)
                .then((response) => {
                    if (response.data.status == 500) {
                        this.showMassage(response.data.message);
                        this.isLoading = false;
                        return;
                    }
                    if (response.data.content > 0) {
                        this.alterarSenha = true;
                        this.form.id_fvw_usuario = response.data.content;
                    } else {
                        this.form.id_fvw_usuario = 0;
                    }
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.showMassage(error.data.message);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        recuperarSenhaCheckMobile() {
            let credentials = {
                codigorecuperacao: this.$route.query.codigo,
            };

            this.$axios
                .post('vendedor/recuperar-senha-check', credentials)
                .then((response) => {
                    if (response.data.status == 500) {
                        this.showMassage(response.data.message);
                        this.isLoading = false;
                        return;
                    }
                    if (response.data.content > 0) {
                        this.alterarSenha = true;
                        this.alterarSenhaMobile = true;
                        this.form.id_vendedor = response.data.content;
                    } else {
                        this.form.id_vendedor = 0;
                    }
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.showMassage(error.data.message);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        alteracaoSenha() {
            this.isLoading = true;

            if (this.isNull(this.form.senha) || this.isNull(this.form.senha2)) {
                this.$root.showMessage('alert', 'msg-campos-obrigatorios', true);
                this.isLoading = false;
            } else if (this.form.senha != this.form.senha2) {
                this.$root.showMessage('alert', 'As senhas não são compativeis', true);
                this.isLoading = false;
                return;
            } else if (!this.verificaParametros(this.form.senha)) {
                this.isLoading = false;
            } else {
                // encripta senha
                let senhaEncripted = this.$CryptoJS.AES.encrypt(
                    this.form.senha,
                    atob(process.env.VUE_APP_DK)
                ).toString();

                let credentials = {
                    password: senhaEncripted,
                    id_fvw_usuario: this.form.id_fvw_usuario,
                    id_vendedor: this.form.id_vendedor,
                };
                if (!this.alterarSenhaMobile) {
                    this.doAlteracaoSenha(credentials);
                } else {
                    this.doAlteracaoSenhaMobile(credentials);
                }
            }
        },
        verificaParametros(senha) {
            if (senha.length > 5 && senha.length < 25) {
                let numbers = /\d/.test(senha);
                let uppercase = /[A-Z]/.test(senha);
                let lowercase = /[a-z]/.test(senha);
                if (numbers && uppercase && lowercase) {
                    return true;
                } else {
                    this.$root.showMessage(
                        'alert',
                        'A senha não preenche aos requisitos necessários!',
                        true
                    );
                    return false;
                }
            }
            this.$root.showMessage('alert', 'O tamanho da senha não condiz a regra', true);
            return false;
        },
        doAlteracaoSenha(credentials) {
            this.$axios
                .post('user/alteracao-senha', credentials)
                .then((response) => {
                    if (response.data.status == 500) {
                        this.showMassage(response.data.message);
                        this.isLoading = false;
                        return;
                    }
                    this.form.email = response.data.content;
                    this.recuperarSenha = false;
                    this.emailEnviado = false;
                    this.alterarSenha = false;
                    this.$root.showMessage('success', 'msg-sucesso-alterar', true);
                    this.removeRouteParams();
                    this.recaptcha();
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.showMassage(error.data.message);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        doAlteracaoSenhaMobile(credentials) {
            this.$axios
                .post('vendedor/alteracao-senha', credentials)
                .then((response) => {
                    if (response.data.status == 500) {
                        this.showMassage(response.data.message);
                        this.isLoading = false;
                        return;
                    }
                    this.recuperarSenha = false;
                    this.emailEnviado = false;
                    this.alterarSenha = false;
                    this.alterarSenhaMobile = false;
                    this.form.senha = null;
                    this.form.senha2 = null;
                    this.$root.showMessage('success', 'msg-sucesso-alterar', true, true, 10);
                    this.removeRouteParams();
                })
                .catch((error) => {
                    if (error.data.message) {
                        this.showMassage(error.data.message);
                    }
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        removeRouteParams() {
            if (!this.isNull(this.$route.query.codigo)) {
                this.$router.push({ query: {} }).catch((error) => {
                    if (
                        error.name !== 'NavigationDuplicated' &&
                        !error.message.includes('Avoided redundant navigation to current location')
                    ) {
                        console.log(error);
                    }
                });
            }
        },
        changeLanguage(name) {
            this.$i18n.locale = name;

            let oldMask = this.$moment.localeData()._config.longDateFormat.L;

            if (name == 'pt') {
                this.$moment.locale('pt-BR');
            } else {
                this.$moment.locale(name);
            }
            this.$store.dispatch('language', { language: this.$moment.locale() });
            let event = new Event('change-locale');
            event.newMask = this.$moment.localeData()._config.longDateFormat.L;
            event.oldMask = oldMask;
            event.convert = (val) => {
                return val
                    ? this.$moment(val, oldMask)._isValid
                        ? this.$moment(val, oldMask).format('L')
                        : val
                    : this.$moment().format('L');
            };
            dispatchEvent(event);
        },
    },
};
</script>
<style lang="scss">
.switch input[type='checkbox']:checked + .check {
    background: var(--primary-color);
}
.switch:hover input[type='checkbox']:checked + .check {
    background: var(--primary-color-hover);
}
</style>
<style lang="scss" scoped>
#copyright-login {
    position: absolute;
    bottom: 5px;
    right: 5px;
    color: $light-gray-color;
}
#lang-login {
    position: absolute;
    left: 3px;

    a.dropdown-item {
        display: flex;
        align-items: center;
        color: $darker-gray-color;
        img {
            margin-right: 10px;
        }
        &:hover {
            color: $darker-gray-color;
        }
    }
}
.login-container {
    height: 100%;
    display: flex;
    flex-grow: 1;
    .logo {
        max-width: 250px;
        height: auto;
        max-height: 200px;
    }
    .login-form {
        width: 40%;
        padding: 15px 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .form-columns-fit {
            width: 80%;
        }
    }
    .login-info {
        width: 60%;
        // background: url('~@/assets/img/sales.jpg'), var(--primary-color-hover);
        background: url('~@/assets/img/hand-shake.jpg'), var(--primary-color-hover);
        background-blend-mode: multiply;
        background-size: cover;
        background-position: center center;
        vertical-align: -webkit-baseline-middle;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        p {
            padding: 20px 50px;
            font-size: 22px;
            font-weight: bolder;
            color: #fff;
            text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
        }
    }
}
@media only screen and (max-width: 1400px) {
    .login-container {
        .login-form {
            width: 50%;
            .form-columns-fit {
                width: 90%;
            }
        }
        .login-info {
            width: 50%;
            p {
                padding: 20px;
                font-size: 18px;
            }
        }
    }
}
@media only screen and (max-width: 1000px) {
    .login-container {
        flex-direction: column;
        min-height: 100%;
        justify-content: space-between;
        height: auto;
        .login-form {
            width: 100%;
            height: 60%;
            .form-columns-fit {
                width: 95%;
            }
        }
        .login-info {
            width: 100%;
            height: 40%;
            p {
                padding: 15px;
                font-size: 16px;
            }
        }
    }
}
</style>
